import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { getSubItemsByItemNo } from "../../utility/service/api-service";
import { Base64Encoder, BcryptEncoder, checkDpSuccess } from "../../utility/service/tool-service";

export default function InventoryCarbonFootprint() {
  const [itemObj, setItemObj] = useState({}); //設定當前點了table哪一筆tr物件(CRUD)
  const [action, setAction] = useState(""); //設定當前點了table哪一筆tr物件(CRUD)
  const [tab1Action, setTab1Action] = useState(""); //設定當前是做哪個動作(CRUD)
  const [reportListObj, setReportListObj] = useState({}); //設定當前選了哪筆報告書
  const [stageList, setStageList] = useState([]);
  const [currentComSeq, setCurrentComSeq] = useState(""); // 紀錄目前所選的廠商名稱
  const [companyName, setCompanyName] = useState(""); // 紀錄目前所選的廠商名稱
  // const [selectedCompanySeq, setSelectedCompanySeq] = useState(null); // 儲存選中的組織

  useEffect(() => {
    axios_getDropdownData();
  }, []);

  const axios_getDropdownData = () => {
    getSubItemsByItemNo("LIFE_CYCLE", 29).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.subItems;
        let newArray = data.map((item, index) => {
          return {
            ...item,
            index: index,
          };
        });
        setStageList(
          newArray?.map((item, index) => {
            return {
              subitemNo: item.subitemNo,
              index,
              stage: convertLifeCycle(item.subitemNo, index),
            };
          })
        );
      }
    });
  };

  const convertLifeCycle = (lifeCycle, index) => {
    return Base64Encoder(BcryptEncoder(lifeCycle)) + "," + index;
  };

  return (
    <Outlet
      context={{
        itemObj,
        setItemObj,
        action,
        setAction,
        setTab1Action,
        tab1Action,
        setReportListObj,
        reportListObj,
        stageList,
        setStageList,
        currentComSeq,
        setCurrentComSeq,
        companyName,
        setCompanyName,
      }}
    />
  );
}
